<div class="sm:hidden mx:block" *ngIf="showPlaceTips">
  <div
    class="bg-error text-base min-h-[48px] flex-v-center mb-2 justify-between"
    *ngIf="placeErrorMessage.length > 0"
  >
    <div class="flex items-center">
      <svg-icon
        [iconName]="'new/info.svg'"
        [size]="20"
        class="mr-3 ml-4"
      ></svg-icon>
      <div>
        <div *ngFor="let error of placeErrorMessage">
          {{ error.severity == "E" ? error.message : "" }}
        </div>
      </div>
    </div>
    <svg-icon
      [iconName]="'new/close.svg'"
      class="mr-5 cursor-pointer"
      (click)="showPlaceTips = false"
    ></svg-icon>
  </div>
</div>
<div class="sm:hidden mx:block" *ngIf="showTips">
  <div
    class="bg-error text-base min-h-[48px] flex-v-center mb-2 justify-between"
    *ngIf="hasErrorMessage || errorMessage.length > 0"
  >
    <div class="flex items-center">
      <svg-icon
        [iconName]="'new/info.svg'"
        [size]="20"
        class="mr-3 ml-4"
      ></svg-icon>
      <div>
        <div *ngIf="hasErrorMessage">{{ "CART_ERROR_TIPS" | translate }}</div>
        <div *ngFor="let error of errorMessage">
          {{ error.severity == "E" ? error.message : "" }}
        </div>
      </div>
    </div>
    <svg-icon
      [iconName]="'new/close.svg'"
      class="mr-5 cursor-pointer"
      (click)="showTips = false"
    ></svg-icon>
  </div>
  <div
    class="bg-warning text-base min-h-[48px] flex-v-center justify-between mb-2"
    *ngIf="messages.length > 0"
  >
    <div class="flex items-center">
      <svg-icon [iconName]="'new/info.svg'" class="mr-3 ml-4"></svg-icon>
      <div>
        <div *ngFor="let message of messages">{{ message.message }}</div>
      </div>
    </div>
    <svg-icon
      [iconName]="'new/close.svg'"
      class="mr-5 cursor-pointer"
      (click)="showTips = false"
    ></svg-icon>
  </div>
  <div
    class="bg-warning text-base min-h-[48px] flex-v-center justify-between mb-2"
    *ngIf="isRequiredDateShouldBeLater"
  >
    <div class="flex items-center">
      <svg-icon
        [iconName]="'new/info.svg'"
        [size]="20"
        class="mr-3 ml-4"
      ></svg-icon>
      <div>
        {{ "REQUIRED_DATE_SHOULD_BE_LATER" | translate }}
      </div>
    </div>
    <svg-icon
      [iconName]="'new/close.svg'"
      class="mr-5 cursor-pointer"
      (click)="showTips = false"
    ></svg-icon>
  </div>
  <div
    class="bg-success text-base h-[48px] flex-v-center justify-between mb-2"
    *ngIf="needSimulate"
  >
    <div class="flex items-center">
      <svg-icon
        [iconName]="'new/info.svg'"
        [size]="20"
        class="mr-3 ml-4"
      ></svg-icon>
      <div>
        {{ "CART_SIMULATE_TIPS" | translate }}
      </div>
    </div>
    <svg-icon
      [iconName]="'new/close.svg'"
      class="mr-5 cursor-pointer"
      (click)="showTips = false"
    ></svg-icon>
  </div>
  <div
    class="bg-success text-base h-[48px] flex-v-center justify-between mb-2"
    *ngIf="placeOrderEnable"
  >
    <div class="flex items-center">
      <svg-icon
        [iconName]="'new/info.svg'"
        [size]="20"
        class="mr-3 ml-4"
      ></svg-icon>
      <div>
        <div>
          {{ "CART_PLACE_ORDER_TIPS" | translate }}
        </div>
      </div>
    </div>
    <svg-icon
      [iconName]="'new/close.svg'"
      class="mr-5 cursor-pointer"
      (click)="showTips = false"
    ></svg-icon>
  </div>
</div>
<ul class="cart-list">
  <li
    *ngFor="let item of productList; let i = index"
    [ngClass]="{
      'bg-white': !(
        item.errorTypes.includes('error') ||
        item.errorTypes.includes('stock_error')
      ),
      'bg-errorBg':
        item.errorTypes.includes('error') ||
        item.errorTypes.includes('stock_error')
    }"
  >
    <div
      class="text-base flex items-center bg-warning h-[48px] p-2"
      *ngIf="getPromptMessages(item).length > 0"
    >
      <svg-icon
        [iconName]="'new/info.svg'"
        [size]="20"
        class="mr-3 ml-2"
      ></svg-icon>
      <div>
        <div *ngFor="let msg of getPromptMessages(item)">
          {{ msg }}
        </div>
      </div>
    </div>
    <div
      class="text-base flex items-center bg-warning h-[48px] p-2"
      *ngIf="
        getMessageByPromotion(
          item.errorMessages,
          item.expectedDate,
          item.lastPickupDate
        ).length > 0 && item.isSimulated
      "
    >
      <svg-icon
        [iconName]="'new/info.svg'"
        [size]="20"
        class="mr-3 ml-2"
      ></svg-icon>
      <div>
        <div
          *ngFor="
            let msg of getMessageByPromotion(
              item.errorMessages,
              item.expectedDate,
              item.lastPickupDate
            )
          "
        >
          {{ msg }}
        </div>
      </div>
    </div>
    <div class="flex flex-wrap mx:px-4 mx:pt-4 sm:px-2 sm:pt-2">
      <!-- material no & checkbox -->
      <div
        class="w-full mx:w-1/2 flex items-center flex-wrap font-bold"
        [ngClass]="{
          'text-greyDisable': item.errorTypes.includes('invalid_error')
        }"
      >
        <svg-icon
          (click)="toggleSelect(item)"
          [iconName]="'new/choosed.svg'"
          *ngIf="item.isSelect"
        ></svg-icon>
        <svg-icon
          (click)="toggleSelect(item)"
          [iconName]="'new/checkbox.svg'"
          *ngIf="!item.isSelect"
        ></svg-icon>
        <span class="sm:min-w-[24px] mx:min-w-[42px] sm:mx-2 mx:ml-4">{{
          item.itemNo
        }}</span>
        <span>{{ item.inputMaterialNumber || "--" }}</span>
        <span class="non-bosch-tag" *ngIf="isOesCountry() && item.isNonBoschPartNo === 1">{{ "NON_BOSCH_PART_NO" | translate }}</span>
        <div
          class="sm:hidden mx:flex items-center ml-4 h-[28px] w-[146px] bg-promotion text-green"
          *ngIf="isInPromotion(item)"
        >
          <svg-icon
            [iconName]="'new/promotions.svg'"
            [size]="20"
            class="px-2"
          ></svg-icon>
          <span class="font-normal">{{ "IN_PROMOTION" | translate }}</span>
        </div>
      </div>
      <div
        class="sm:flex mx:hidden items-center ml-[64px] h-[28px] w-[146px] bg-promotion text-green"
        *ngIf="isInPromotion(item)"
      >
        <svg-icon
          [iconName]="'new/promotions.svg'"
          [size]="20"
          class="px-2"
        ></svg-icon>
        <span class="font-normal">{{ "IN_PROMOTION" | translate }}</span>
      </div>
      <!-- wait simulate operation -->
      <div class="order-3 mx:order-2 w-full mx:w-1/2 sm:ml-8 sm:mb-2">
        <div class="flex flex-row-reverse sm:justify-end items-center">
          <svg-icon
            [iconName]="'new/delete.svg'"
            [title]="'DELETE' | translate"
            (click)="removeFromCart(item.id)"
            class="cursor-pointer"
          ></svg-icon>
          <svg-icon
            [iconName]="'new/wishlist.svg'"
            [title]="'SAVE_FOR_LATER' | translate"
            *ngIf="!item.errorTypes.includes('invalid_error')"
            (click)="moveToWhishList(item)"
            class="mr-4 cursor-pointer"
          ></svg-icon>
          <svg-icon
            [iconName]="'new/notification.svg'"
            nz-popover
            [nzPopoverPlacement]="'top'"
            [nzPopoverContent]="msgTemplate"
            class="mr-4"
            *ngIf="item.errorMessages.length > 0 || getPromptMessages(item).length > 0"
          ></svg-icon>
          <div
            class="flex items-center mr-4"
            *ngIf="
              getMessagesByType(item.errorMessages, 'E').length == 0 &&
              item.isSimulated
            "
          >
            <svg-icon [iconName]="'new/orderable.svg'" class="mr-2"></svg-icon>
            <span class="text-base text-warningTips">{{
              "ORDERABLE" | translate
            }}</span>
          </div>
          <div
            class="flex items-center mr-4"
            *ngIf="getMessagesByType(item.errorMessages, 'E').length > 0"
          >
            <svg-icon
              [iconName]="'new/not_orderable.svg'"
              class="mr-2"
            ></svg-icon>
            <span
              class="text-base text-errorTips"
              *ngIf="getMessagesByType(item.errorMessages, 'E').length > 0"
              >{{ "NOT_ORDERABLE" | translate }}</span
            >
          </div>
          <div
            class="flex items-center mr-4"
            *ngIf="
              !item.isSimulated &&
              getMessagesByType(item.errorMessages, 'E').length == 0
            "
          >
            <svg-icon
              [iconName]="'new/wait_simulate.svg'"
              class="mr-2"
            ></svg-icon>
            <span
              class="text-base text-grey700"
              *ngIf="
                !item.isSimulated &&
                getMessagesByType(item.errorMessages, 'E').length == 0
              "
              >{{ "WAIT_SIMULATION" | translate }}</span
            >
          </div>
        </div>
      </div>
      <!-- info -->
      <div
        class="order-2 mx:order-3 w-full mt-2"
        [ngClass]="{
          'text-greyDisable': item.errorTypes.includes('invalid_error')
        }"
      >
        <div class="mx:ml-[82px] flex flex-wrap justify-between">
          <!-- product & material no -->
          <div
            class="sm:ml-8 mx:mb-4 sm:mb-1 w-full mx:w-[calc(25%-0.25rem)] min-w-[180px] flex-grow"
          >
            <div class="line-height30 h-[30px] mb-1 flex-v-center">
              <span
                class="truncate max-w-[80%]"
                [attr.title]="item.productName"
                >{{ item.productName || "--" }}</span
              >
              <svg-icon
                [iconName]="'new/arrow.svg'"
                nz-popover
                [nzPopoverPlacement]="'top'"
                [nzPopoverContent]="infoTemplate"
                [size]="10"
                *ngIf="item.productName"
                class="ml-2 arrow"
              ></svg-icon>
            </div>
            <div class="h-[40px] line-height40">
              {{ item.materialNumber || "--" }}
            </div>
            <div class="mb-1" *ngIf="item.referenceFrom">
              {{ "REF_FROM" | translate }}:<span class="ml-2">{{
                item.referenceFrom
              }}</span>
            </div>
            <div *ngIf="item.poItemNumber && item.referenceFrom">
              {{ "PO_ITEM_NO" | translate }}:<span class="ml-2">{{
                item.poItemNumber
              }}</span>
            </div>
          </div>

          <!-- qty & moq -->
          <div
            class="w-full mx:w-[calc(25%-0.25rem)] min-w-[220px] flex-grow sm:ml-8 mx:mb-4 sm:mb-1"
          >
            <div class="h-[30px] line-height30">
              {{ "QUANTITY" | translate }}
            </div>
            <!-- -->
            <div class="bg-grey h-[40px] w-[200px] mb-1">
              <quantity-input
                mode="list"
                [(quantity)]="item.quantity"
                [moq]="item.minimumOrderQuantity"
                [errorTypes]="item.errorTypes"
                (quantityBlur)="quantityBlur($event, item)"
                (quantityChange)="quantityChange($event, item)"
              ></quantity-input>
            </div>
            <div
              class="mb-1 text-grey900"
              *ngIf="item.inputQuantity != item.quantity && !isChanging"
            >
              {{ "INPUT_NO" | translate }}:<span class="ml-2">{{
                item.inputQuantity
              }}</span>
            </div>
            <div class="text-grey900" *ngIf="item.isSimulated">
              {{ "MOQ" | translate }}:<span class="ml-2">{{
                item.minimumOrderQuantity
              }}</span>
            </div>
          </div>

          <!-- expected date -->
          <div
            class="w-full mx:w-[calc(25%-0.25rem)] min-w-[220px] flex-grow sm:ml-8 mx:mb-4 sm:mb-1"
          >
            <div class="h-[30px] line-height30">
              {{ "ADD_DATE" | translate }}
            </div>
            <div class="h-[40px] w-[228px] mb-1 flex items-center">
              <nz-date-picker
                class="calender-picker w-[200px]"
                [ngClass]="{
                  error_date: item.errorTypes.includes('date_error')
                }"
                (ngModelChange)="onDatePickerChange($event, item)"
                [nzDisabled]="item.errorTypes.includes('invalid_error')"
                [nzSuffixIcon]="suffixDate"
                [nzAllowClear]="false"
                [nzPlaceHolder]="'CART_DELIVERY_DATE' | translate"
                nzFormat="yyyy-MM-dd"
                [ngModel]="item.expectedDate"
                [nzDisabledDate]="disabledDate"
              ></nz-date-picker>
              <ng-template #suffixDate>
                <svg-icon
                  [iconName]="
                    item.errorTypes.includes('invalid_error')
                      ? 'new/calendar-grey.svg'
                      : 'new/calendar.svg'
                  "
                  [size]="20"
                ></svg-icon>
              </ng-template>
              <!-- <div *ngIf="country!=='/oes'">
              <svg-icon class="ml-1" [size]="20" *ngIf="item.stockQuantity!==''"
              [iconName]="item.stockQuantity===0?'new/red.svg':(item.quantity<=item.stockQuantity?'new/green.svg':'new/yellow.svg')" nz-popover [nzPopoverPlacement]="'top'"
              [nzPopoverContent]="stockTemplate"></svg-icon>
            </div> -->
            </div>
            <div
              *ngIf="
                item.simulateDeliveryInfoList.length > 0 && item.isSimulated
              "
            >
              <div
                class="mb-1"
                *ngFor="let deliveryInfo of getDeliveryInfoListForDisplay(item.simulateDeliveryInfoList)"
                [ngClass]="{
                  'color-warning':
                    deliveryInfo.deliveryDate > item.expectedDate,
                  'color-green': deliveryInfo.deliveryDate <= item.expectedDate
                }"
              >
                {{ deliveryInfo.deliveryDate }}<ng-container *ngIf="shouldShowDeliveryQuantity()">:<span class="ml-2">{{
                  deliveryInfo.quantity
                }}</span></ng-container>
              </div>
            </div>
          </div>

          <!-- price -->
          <div
            class="w-full mx:w-[calc(25%-0.25rem)] min-w-[220px] flex-grow sm:ml-8 mx:mb-4 sm:mb-1"
          >
            <div class="mb-1 h-[30px] line-height30" *ngIf="item.isSimulated">
              {{ "NET_PRICE" | translate }}:<span class="ml-2 text-greyDisable"
                >{{ item.netPrice.currency }}
                {{ (item.netPrice.value | number : "1.2-2") || "--" }}</span
              >
            </div>
            <div class="mb-1 h-[40px] line-height40" *ngIf="item.isSimulated">
              {{ "CART_TOTAL_VALUE" | translate }}:<span
                class="ml-2 mr-2 text-greyDisable truncate"
                >{{ item.totalAmount.currency }}
                {{ (item.totalAmount.value | number : "1.2-2") || "--" }}</span
              >
              <svg-icon
                [iconName]="'new/arrow-grey.svg'"
                [size]="10"
                class="text-greyDisable"
                nz-popover
                [nzPopoverPlacement]="'top'"
                [nzPopoverContent]="priceTemplate"
              ></svg-icon>
            </div>
          </div>
        </div>
      </div>
      <div
        class="mx:ml-[82px] sm:ml-8 order-4 mx:mb-4 sm:mb-1 line"
        *ngIf="isInPromotion(item)"
      ></div>
    </div>
    <!-- promotions -->
    <div
      *ngIf="
        item.isSimulated &&
        getIsBeforeLastPickupDate(item.expectedDate, item.lastPickupDate)
      "
      class="mx:px-4 mx:pb-4 sm:px-2 sm:pb-2"
    >
      <div
        class="ml-[82px] sm:ml-8"
        *ngFor="let promotion of item.components; let j = index"
      >
        <!-- item  & material -->
        <div class="w-full mx:w-1/2 flex items-center flex-wrap font-bold">
          <span class="mr-4">{{ promotion.itemNo }}</span>
          <span>{{ promotion.materialNumber || "--" }}</span>
          <div
            *ngIf="promotion.isGift && item.isSimulated"
            class="sm:hidden mx:flex items-center ml-4 h-[28px] w-[116px] bg-purpleBg text-purple"
          >
            <svg-icon [iconName]="'new/gift.svg'" class="px-2"></svg-icon>
            <span class="font-normal">{{ "GIVEAWAY" | translate }}</span>
          </div>
        </div>
        <div
          *ngIf="promotion.isGift && item.isSimulated"
          class="sm:flex mx:hidden items-center ml-[36px] h-[28px] w-[116px] bg-purpleBg text-purple"
        >
          <svg-icon [iconName]="'new/gift.svg'" class="px-2"></svg-icon>
          <span class="font-normal">{{ "GIVEAWAY" | translate }}</span>
        </div>
        <!-- promotions info -->
        <div class="flex flex-wrap justify-between pt-2">
          <!-- product & material no -->
          <div
            class="w-full mx:w-[calc(25%-0.25rem)] min-w-[220px] flex-grow mx:mb-4 sm:mb-1"
          >
            <div class="line-height30 h-[30px] mb-1 flex-v-center">
              <span
                class="truncate max-w-[80%]"
                [attr.title]="promotion.productName"
                >{{ promotion.productName || "--" }}</span
              >
              <svg-icon
                [iconName]="'new/arrow.svg'"
                [size]="10"
                nz-popover
                [nzPopoverPlacement]="'top'"
                [nzPopoverContent]="promotionInfoTemplate"
                *ngIf="promotion.productName"
                class="ml-2 arrow"
              ></svg-icon>
            </div>
            <div class="h-[30px] line-height30">
              {{ promotion.materialNumber || "--" }}
            </div>
          </div>

          <!-- qty & moq -->
          <div
            class="w-full mx:w-[calc(25%-0.25rem)] min-w-[220px] flex-grow mx:mb-4 sm:mb-1"
          >
            <div class="h-[30px] line-height30 w-[220px] mb-1">
              {{ "QUANTITY" | translate }}
            </div>
            <div class="text-greyDisable h-[30px] line-height30">
              {{ promotion.quantity || "--" }}
            </div>
          </div>

          <!-- expected date -->
          <div
            class="w-full mx:w-[calc(25%-0.25rem)] min-w-[220px] flex-grow mx:mb-4 sm:mb-1"
          >
            <div class="mb-1 h-[30px] line-height30 w-[220px]">
              {{ "ADD_DATE" | translate }}
            </div>
            <div class="h-[30px] line-height30 mb-1">
              <span>{{ item.expectedDate }}</span>
              <svg-icon
                class="ml-2"
                [size]="20"
                *ngIf="!item.isSimulated && promotion.stockQuantity !== ''"
                [iconName]="
                  promotion.stockQuantity === 0
                    ? 'new/red.svg'
                    : promotion.quantity <= promotion.stockQuantity
                    ? 'new/green.svg'
                    : 'new/yellow.svg'
                "
                nz-popover
                [nzPopoverPlacement]="'top'"
                [nzPopoverContent]="promotionStockTemplate"
              ></svg-icon>
            </div>
            <div
              *ngIf="
                promotion.simulateDeliveryInfoList.length > 0 &&
                item.isSimulated
              "
            >
              <div
                class="mb-1 h-[30px] line-height30"
                *ngFor="let deliveryInfo of getDeliveryInfoListForDisplay(promotion.simulateDeliveryInfoList)"
                [ngClass]="{
                  'text-yellow': deliveryInfo.deliveryDate > item.expectedDate,
                  'text-warningTips':
                    deliveryInfo.deliveryDate <= item.expectedDate
                }"
              >
                {{ deliveryInfo.deliveryDate }}<ng-container *ngIf="shouldShowDeliveryQuantity()">:<span class="ml-2">{{
                  deliveryInfo.quantity
                }}</span></ng-container>
              </div>
            </div>
            <ng-template #promotionStockTemplate>
              <div class="price-info">
                {{
                  promotion.stockQuantity === 0
                    ? ("NO_STOCK" | translate)
                    : promotion.quantity <= promotion.stockQuantity
                    ? ("IN_STOCK" | translate)
                    : ("LOW_STOCK" | translate)
                }}
              </div>
            </ng-template>
          </div>

          <!-- price -->
          <div
            class="w-full mx:w-[calc(25%-0.25rem)] min-w-[220px] flex-grow mx:mb-4 sm:mb-1"
          >
            <div class="mb-1 h-[30px] line-height30 w-[220px]">
              {{ "NET_PRICE" | translate }}:<span class="ml-2 text-greyDisable"
                >{{ promotion.netPrice.currency }}
                {{
                  (promotion.netPrice.value | number : "1.2-2") || "--"
                }}</span
              >
            </div>
          </div>

          <ng-template #promotionInfoTemplate>
            <div class="price-info">
              <div class="flex">
                <span class="info-title color-black font16-w500"
                  >{{ "EAN" | translate }}:</span
                >
                <span class="color-grey7C font16-w500">{{
                  promotion.ean || "--"
                }}</span>
              </div>
              <div class="flex">
                <span class="info-title color-black font16-w500"
                  >{{ "CART_VOLUME" | translate }}:</span
                >
                <span class="color-grey font16-w500"
                  >{{
                    promotion.shipmentDimension?.totalVolume
                      ? (promotion.shipmentDimension.totalVolume
                          | number : "1.2-2") +
                        promotion.shipmentDimension?.unitOfVolume
                      : "--"
                  }}
                </span>
              </div>
              <div class="flex">
                <span class="info-title color-black font16-w500"
                  >{{ "CART_WEIGHT" | translate }}:</span
                >
                <span class="color-grey font16-w500">{{
                  promotion.shipmentDimension?.totalWeight
                    ? (promotion.shipmentDimension.totalWeight
                        | number : "1.2-2") +
                      promotion.shipmentDimension?.unitOfWeight
                    : "--"
                }}</span>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- error msg -->
    <div
      class="error_msg pl-10 pr-4 pb-4"
      *ngIf="hasItemMessages(item)"
    >
      <p
        class="text-errorTips"
        [ngClass]="{
          'text-errorTips': msg.severity == 'E',
          'color-warning': msg.severity == 'W'
        }"
        *ngFor="let msg of getMessagesExcludingPromotion(item.errorMessages)"
      >
        {{ msg.message }}
      </p>
      <p class="color-warning" *ngFor="let msg of getPromptMessages(item)">
        {{ msg }}
      </p>
    </div>

    <ng-template #msgTemplate>
      <div class="msg_tips">
        <ng-container>
          <div class="flex" *ngFor="let msg of item.errorMessages">
            <i
              class="tip_item"
              [ngClass]="{
                'bg-errorTips': msg.severity == 'E',
                'bg-yellow': msg.severity == 'W'
              }"
            ></i>
            <p>{{ msg.message }}</p>
          </div>
          <div class="flex" *ngFor="let msg of getPromptMessages(item)">
            <i class="tip_item bg-yellow"></i>
            <p>{{ msg }}</p>
          </div>
        </ng-container>
      </div>
    </ng-template>

    <ng-template #infoTemplate>
      <div class="price-info">
        <div class="flex">
          <span class="info-title color-black font16-w500"
            >{{ "EAN" | translate }}:</span
          >
          <span class="color-grey7C font16-w500">{{ item.ean || "--" }}</span>
        </div>
        <div class="flex">
          <span class="info-title color-black font16-w500"
            >{{ "CART_VOLUME" | translate }}:</span
          >
          <span class="color-grey font16-w500">{{
            item.shipmentDimension?.totalVolume
              ? (item.shipmentDimension.totalVolume | number : "1.2-2") +
                item.shipmentDimension?.unitOfVolume
              : "--"
          }}</span>
        </div>
        <div class="flex">
          <span class="info-title color-black font16-w500"
            >{{ "CART_WEIGHT" | translate }}:</span
          >
          <span class="color-grey font16-w500"
            >{{
              item.shipmentDimension?.totalWeight
                ? (item.shipmentDimension.totalWeight | number : "1.2-2") +
                  item.shipmentDimension?.unitOfWeight
                : "--"
            }}
          </span>
        </div>
      </div>
    </ng-template>

    <ng-template #stockTemplate>
      <div class="price-info">
        {{
          item.stockQuantity === 0
            ? ("NO_STOCK" | translate)
            : item.quantity <= item.stockQuantity
            ? ("IN_STOCK" | translate)
            : ("LOW_STOCK" | translate)
        }}
      </div>
    </ng-template>

    <ng-template #priceTemplate>
      <div class="price-info">
        <div class="flex">
          <span
            class="price-info-title mx:w-[166px] sm:w-[100px] color-black font16-w700"
            >{{ "CART_TOTAL_VALUE" | translate }}:</span
          >
          <span class="color-blue font16-w700"
            >{{ item.totalAmount.currency }}
            {{ (item.totalAmount.value | number : "1.2-2") || "--" }}</span
          >
        </div>
        <div class="flex-v-center">
          <span
            class="price-info-title mx:w-[166px] sm:w-[100px] color-black font16-w500"
            >{{ "NET_PRICE" | translate }}:</span
          >
          <span class="color-grey7C font16-w500"
            >{{ item.netPrice.currency }}
            {{ (item.netPrice.value | number : "1.2-2") || "--" }}</span
          >
        </div>
        <div class="flex">
          <span
            class="price-info-title mx:w-[166px] sm:w-[100px] color-black font16-w500"
            >{{ "NET_VALUE" | translate }}:</span
          >
          <span class="color-grey font16-w500"
            >{{ item.netValue.currency }}
            {{ (item.netValue.value | number : "1.2-2") || "--" }}</span
          >
        </div>
        <div class="flex" *ngIf="item.totalFreight?.value">
          <span
            class="price-info-title mx:w-[166px] sm:w-[100px] color-black font16-w500"
            >{{ "TOTAL_FREIGHT" | translate }}:</span
          >
          <span class="color-grey font16-w500"
            >{{ item.totalFreight.currency }}
            {{ (item.totalFreight.value | number : "1.2-2") || "--" }}</span
          >
        </div>
        <div class="flex" *ngIf="item.bonusDiscount?.value">
          <span
            class="price-info-title mx:w-[166px] sm:w-[100px] color-black font16-w500"
            >{{ "PROMOTION" | translate }}:</span
          >
          <span class="color-grey font16-w500"
            >{{ item.bonusDiscount.currency }}
            {{ (item.bonusDiscount.value | number : "1.2-2") || "--" }}</span
          >
        </div>
        <div class="flex" *ngIf="item.movSurcharge?.value">
          <span
            class="price-info-title mx:w-[166px] sm:w-[100px] color-black font16-w500"
            >{{ "MOV_SURCHARGE" | translate }}:</span
          >
          <span class="color-grey font16-w500"
            >{{ item.movSurcharge.currency }}
            {{ (item.movSurcharge.value | number : "1.2-2") || "--" }}</span
          >
        </div>
        <div class="flex">
          <span
            class="price-info-title mx:w-[166px] sm:w-[100px] color-black font16-w500"
            >{{ "TAX" | translate }}:</span
          >
          <span class="color-grey font16-w500"
            >{{ item.tax.currency }}
            {{ (item.tax.value | number : "1.2-2") || "--" }}</span
          >
        </div>
      </div>
    </ng-template>
  </li>
</ul>

<!-- <div class="flex flex-wrap justify-between ml-[98px]">
  <div class="w-full mx:w-[calc(20%-0.25rem)] min-w-[220px] bg-green h-24">1</div>
  <div class="w-full mx:w-[calc(25%-0.25rem)] min-w-[220px] bg-green h-24">2</div>
  <div class="w-full mx:w-[calc(25%-0.25rem)] min-w-[220px] bg-green h-24">3</div>
  <div class="w-full mx:w-[calc(25%-0.25rem)] min-w-[220px] bg-green h-24">4
  </div>
</div> -->
